import { handleActions } from "redux-actions";
import { ACTIONS } from "./actions";

const initialState: SettingsState = {
	mock: null,
};

export default handleActions(
	{
		[`${ACTIONS.MOCK_ACTION}_PENDING`]: (state) => ({ ...state }),
		[`${ACTIONS.MOCK_ACTION}_REJECTED`]: (state, action) => ({ ...state }),
		[`${ACTIONS.MOCK_ACTION}_FULFILLED`]: (state, action) => ({ ...state }),
	},
	initialState
);

export interface SettingsState {
	mock: any;
}
